import React from 'react';
import cs from '../../../utils/const.js';
import AntAuth from '../../../utils/AntAuth.js';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import Button from 'devextreme-react/button';
import List from 'devextreme-react/list';
import './index.scss';
import { FaUserCircle } from 'react-icons/fa';

export default class AntUserPanel extends React.Component {
    render() {
        const { menuMode, menuItems } = this.props;
        let userName = AntAuth.getSessionInfo('user_name');
        let empName = AntAuth.getSessionInfo('employee_name');
        let empFullName = AntAuth.getSessionInfo('employee_full_name');
        let txtName = [empFullName, empName, userName].filter((t) => Boolean(t)).shift();
        
        return (
            <Button id={'userName'} className={'ant-main-header-user-button authorization'} width={30} height={'100%'} stylingMode={'text'}>
                <div className={'user-panel'}>
                    <div className={'user-info'}>
                        <div className={'user-name'}>{txtName}</div>
                        <FaUserCircle className={'user-image'} />
                    </div>
                    <ContextMenu items={menuItems} target={'.ant-main-header-user-button'} showEvent={'dxclick'} cssClass={'user-menu'}>
                        <Position my={'right top'} at={'right bottom'} target={window} />
                    </ContextMenu>
                </div>
            </Button>
        );
    }
}
